import { render, staticRenderFns } from "./HorizontalScrollMenu.vue?vue&type=template&id=8fd80f68&scoped=true&"
import script from "./HorizontalScrollMenu.vue?vue&type=script&lang=js&"
export * from "./HorizontalScrollMenu.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalScrollMenu.vue?vue&type=style&index=0&id=8fd80f68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd80f68",
  null
  
)

export default component.exports